import React from 'react';
import styles from './DrawerToggle.css';
const drawerToggle = (props) => {
  return (
    <div onClick = {props.clicked} className = {styles.DrawerToggle}>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default drawerToggle;



// WEBPACK FOOTER //
// ./src/components/Navigation/SideDrawer/DrawerToggle/DrawerToggle.js